<h2 mat-dialog-title>Conteúdo do Currículo</h2>
<mat-dialog-content>
    <p class="mat-body-2">
        Algumas informações necessárias para o seu currículo estão faltando. Por favor, preencha-as para que possamos gerar o seu currículo.
    </p>
    <mat-action-list>
        <button *ngIf="empty.sobre_candidato" mat-list-item [routerLink]="['/', 'customer', 'profile']"
            mat-dialog-close>
            <mat-icon color="accent" matListIcon>person_edit</mat-icon>
            <h3 matLine>Sobre você</h3>
            <p matLine>Preencha essa infomação para colocar um resumo sobre você</p>
        </button>
        <ng-container *ngIf="empty.professional_experiences">
            <button mat-list-item [routerLink]="['/', 'customer', 'experiences']" mat-dialog-close>
                <mat-icon color="accent" matListIcon>work</mat-icon>
                <h3 matLine>Experiencias Profissionais</h3>
                <p matLine>Monte seu histórico profissional</p>
            </button>
            <button mat-list-item *ngIf="firstJob" [mat-dialog-close]="true">
                <mat-icon color="primary" matListIcon>emoji_people</mat-icon>
                <h3 matLine>Meu primeiro emprego</h3>
                <p matLine>Estou procurando meu primeiro emprego</p>
            </button>
        </ng-container>
        <button *ngIf="empty.education_experiences" mat-list-item [routerLink]="['/', 'customer', 'schooling']"
            mat-dialog-close>
            <mat-icon color="accent" matListIcon>school</mat-icon>
            <h3 matLine>Nivel Educacional</h3>
            <p matLine>Informe os cursos, e instituições de ensino que você frequentou</p>
        </button>
    </mat-action-list>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="accent" mat-dialog-close>Fechar</button>
</mat-dialog-actions>